export default __webpack_public_path__ + "static/media/instagram.b7c3a981.svg";